const readCookie = (name) => {
  let cookies = document?.cookie?.split(';');
  return cookies?.find(cookie => cookie?.trim()?.split('=')[0] === name)?.split('=')[1] ?? null;
}

export const Config = {
    // Domain and API full URLs
    API: (readCookie('API') || process.env.REACT_APP_API || '').trim().replace(/\/+$/, "") + '/',
};
